/* global globalThis */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TimeUtils } from "examsbook-react-sdk/common";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useStyles, usePopupHandlerOnUnload, useQuizCountDown, useTranslations } from "examsbook-react-sdk/custom-hooks";
import TimerIcon from '../../../assets/images/Timer.png'
import CommonButton from '../../../constants/CommonButton';
import { Redirect } from 'react-router-dom';
import { Typography, Box, CircularProgress } from '@material-ui/core';
import { ColorsConstant } from '../../../constants/colorConstant';
import TimeOverIcon from "../../../assets/images/timeOver.png";
import { useSelector } from 'react-redux';
/**
 * Quiz timer.
 * @param props
 * @returns {*}
 * @constructor
 */
function QuizTimer(props) {
    const classes = useStyles(styles)();
    const { mode, viewMode, usedTime, setTimeTaken, pauseQuiz, submitQuiz, newTime, slug, handleClick, selectTimeFor, hideNext, reset, setReset, courseId } = props;
    const secondsLeft = useQuizCountDown(newTime, usedTime, pauseQuiz, viewMode, reset, selectTimeFor);
    const t = useTranslations();
    const [redirectToReports, setRedirectToReports] = useState(false);
    const [quizSubmitted, setQuizSubmitted] = useState(false);
    const [quizStarted, setQuizStarted] = useState(false);
    const quizResultData = useSelector((state) => state.getQuizResultReducer.quizResult);
    const [showTimeUpModal, setShowTimeUpModal] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const isLoadingQuizResponse = useSelector((state) => state.getQuizResultReducer.isLoading);

    // Keep elapsed time in sync without triggering updates during render.
    useEffect(() => {
        setTimeTaken((newTime * 60) - secondsLeft);
    }, [newTime, secondsLeft, setTimeTaken]);

    usePopupHandlerOnUnload(secondsLeft > 0, viewMode);
    const time = TimeUtils.secondsToTime(secondsLeft);
   
    useEffect(() => {
        if(secondsLeft === 0 && !viewMode && !quizSubmitted && selectTimeFor && !hideNext && selectTimeFor === "QUESTION") {
            handleClick('next')
            setReset(prev => !prev);
        }
    }, [secondsLeft, viewMode, quizSubmitted, selectTimeFor, hideNext, handleClick, setReset]);

    useEffect(() => {
        if (!quizStarted) {
            setQuizStarted(true);
            return;
        }
        if (!quizSubmitted && (hideNext || selectTimeFor === "QUIZ") && secondsLeft === 0) {
            setShowTimeUpModal(true);
        }
    }, [quizSubmitted, hideNext, selectTimeFor, secondsLeft, quizStarted]);

    useEffect(() => {
        if (showLoader && !isLoadingQuizResponse) {
            setShowLoader(false);
            setShowResult(true);
        }
    }, [isLoadingQuizResponse, showLoader]);

    const currentPath = globalThis?.location?.pathname || '';

    const handleResultOk = () => {
        setRedirectToReports(true);
    };


    const handleTimeUpSubmit = () => {
        setShowLoader(true);
        submitQuiz();
        setQuizSubmitted(true);
    };

    const isViewMode = viewMode === true;
    const isQuizTimer = selectTimeFor === "QUIZ";
    const isTimerNearEnd = (mode === 'mock-test' || mode === 'live-test') && time.h === 0 && +time.m < 3;
    const formattedTime = `${(time.h > 0 ? ("0" + time.h).slice(-2) : '00')}:${("0" + time.m).slice(-2)}:${("0" + time.s).slice(-2)}`;
    const shouldShowTimeUpModal = showTimeUpModal && isLoadingQuizResponse === false;

    function renderTimer() {
        return (
            <Typography
                className={classes.timer + ' ' + (isTimerNearEnd ? classes.blinkTimer : '')}>
                {isViewMode ? null : (
                    <img alt='' className={classes.showTimerIcon} src={TimerIcon} style={{ marginRight: 7 }}></img>
                )}
                {isViewMode ? '' : formattedTime}
                <Box className={classes.timerTag}>
                    <Typography>{isQuizTimer && !isViewMode ? t('Quiz Timer') : t('Question Timer')}</Typography>
                </Box>
            </Typography>
        );
    }

    let modalContent = null;
    if (showLoader) {
        modalContent = (
            <Box className={classes.modalBg}>
                <Box className={classes.modalContent} onClick={e => e.stopPropagation()}>
                    <Box className={classes.heading} sx={{ p: 2 }}>
                        <CircularProgress style={{ color: '#0C3450' }} />
                        <Typography variant="h2" className={classes.quizTitle}>
                            {t("Please wait, your result is getting prepared")}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        );
    } else if (showResult) {
        modalContent = (
            <Box className={classes.modalBg}>
                <Box className={classes.modalContent} onClick={e => e.stopPropagation()}>
                    <Box className={classes.heading}>
                        {quizResultData?.error ? (
                            <Typography variant="h2" className={classes.quizTitle}>
                                {t("There was an issue while submitting the quiz.")}
                            </Typography>
                        ) : (
                            <Typography variant="h2" className={classes.quizTitle}>
                                {t("Your quiz is submitted successfully!")}
                            </Typography>
                        )}
                        <Box className={classes.okBtn} onClick={handleResultOk}>{t("Ok")}</Box>
                    </Box>
                </Box>
            </Box>
        );
    } else if (shouldShowTimeUpModal) {
        modalContent = (
            <Box className={classes.modalBg}>
                <Box
                    className={classes.modalContent}
                    style={{ borderTop: `16px solid ${ColorsConstant.defaultBlue}` }}
                    onClick={e => e.stopPropagation()}>
                    <Box component="img" className={classes.imgHeight} src={TimeOverIcon} alt="pause quiz icon" />
                    <Typography className={classes.heading}>{t(`Time's Up!`)} ⏳</Typography>
                    <Typography className={classes.quizTitle}>{t(`Your quiz session has ended. Don't worry every attempt is a step towards learning`)}</Typography>
                    <Box className={classes.okAlign}>
                        <CommonButton onClick={handleTimeUpSubmit} classStyleHeading={classes.okBtn} title={t("Submit")} />
                    </Box>
                </Box>
            </Box>
        );
    }

    return (
        <React.Fragment>
            {modalContent}
            {redirectToReports && (
                <Redirect
                    to={{
                        pathname: `/reports/${slug}/${courseId}`,
                        state: {
                            courseId: courseId,
                            slug: slug,
                            pageType: "afterTestResult",
                            params: currentPath,
                        },
                    }}
                />
            )}
            {redirectToReports ? null : renderTimer()}
        </React.Fragment>
    );
}

const styles = theme => ({
    timer: {
        top: 7,
        left: 0,
        right: 'inherit',
        height: 40,
        display: 'flex',
        alignItems: 'center',
        padding: '3px 10px',
        textAlign: 'left',
        lineHeight: '40px',
        color: '#000000',
        fontSize: 16,
        flexWrap: 'wrap',
        minWidth: 100,
        position: 'relative',
        '& i': {
            display: 'flex',
            fontSize: 18,
            marginRight: 5
        },
        '& .MuiLinearProgress-colorPrimary': {
            backgroundColor: '#FFFFFF',
            marginTop: -4,
            width: '100%',
            display: 'flex',
            '& > div': {
                backgroundColor: '#FFFFFF'
            }
        },
        '@media (min-width:280px) and (max-width:320px)': {
            top: -1,
            left: 0,
            right: 'inherit',
            height: 'auto',
            display: 'contents',
            alignItems: 'center',
            padding: '3px 10px',
            textAlign: 'left',
            lineHeight: '40px',
            fontSize: 14,
            flexWrap: 'wrap',
            minWidth: 100,
        },
        '@media (min-width:321px) and (max-width:767px)': {
            top: -1,
            left: 0,
            right: 'inherit',
            height: 'auto',
            display: 'contents',
            alignItems: 'center',
            padding: '3px 10px',
            textAlign: 'left',
            lineHeight: '40px',
            fontSize: 14,
            flexWrap: 'wrap',
            minWidth: 100,
            width: 100,
        },
        '@media (min-width:768px) and (max-width:2560px)': {
            top: -1,
            left: 20,
            right: 'inherit',
            height: 'auto',
            display: 'flex',
            alignItems: 'center',
            padding: '3px 10px',
            textAlign: 'left',
            lineHeight: '40px',
            fontSize: 20,
            flexWrap: 'wrap',
            minWidth: 100,
        }
    },
    okBtn: {
        color: '#fff',
        textTransform: 'capitalize',
        borderRadius: '4px',
        padding: '10px 30px',
        cursor: 'pointer',
        margin: '15px',
        fontSize: '18px',
        fontWeight: '500',
        backgroundColor: '#0C3450',
        '&:hover': {
            backgroundColor: '#0c3450e0 !important',
        },
    },
    showTimerIcon: {
        display: 'none',
        '@media (min-width:767px)': {
            display: 'block'
        }

    },
    modalBg: {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: '999999',
        position: 'fixed',
        background: '#00000080'
    },
    modalContent: {
        backgroundColor: '#fff',
        position: 'absolute',
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: '16px',
        borderRadius: '6px',
        width: '460px',
        '@media (max-width:1024px)': {
            width: '300px'
        }
    },
    okAlign: {
        display:'flex',
        flexDirection:'row',
        justifyContent: 'center'
    },
    heading: {
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        backgroundColor:'#fff',
        fontSize: '18px',
        color: `${ColorsConstant.descriptionColor}`,
        padding:'8px 40px',
        borderRadius: '6px'
    },
    quizTitle: {
        fontSize: '18px',
        textAlign: 'center',
        color: `${ColorsConstant.descriptionColor}`,
        fontWeight: 'normal',
        lineHeight: '24px',
        marginBlockStart: '0.83em',
        marginBlockEnd: '0.83em',
    },
    timerTag: {
        border: `1px solid ${ColorsConstant.defaultBlue}`,
        borderRadius: '4px',
        color: ColorsConstant.defaultBlue,
        padding: '0px 16px',
        position: 'relative',
        left: '16px',
        '@media (max-width:767px)': {
            left: '0px',
            margin: '10px',
            '& p': {
                fontSize: '10px',
                width: 'max-content'
            }
        }
    },
    imgHeight: {
        margin: '16px 0px'
    }
});

QuizTimer.propTypes = {
    mode: PropTypes.string,
    viewMode: PropTypes.bool,
    usedTime: PropTypes.number,
    setTimeTaken: PropTypes.func,
    pauseQuiz: PropTypes.bool,
    submitQuiz: PropTypes.func,
    newTime: PropTypes.number,
    slug: PropTypes.string,
    handleClick: PropTypes.func,
    selectTimeFor: PropTypes.string,
    hideNext: PropTypes.bool,
    reset: PropTypes.bool,
    setReset: PropTypes.func,
    courseId: PropTypes.string,
};

export default QuizTimer;
